import React, {useEffect} from "react";
import "./index.scss";
import {COLORS} from "@/style/utils";

const Rating = (props) => {
	const {
		selectedRating,
		setSelectedRating,
		label,
		required,
		disabled = false,
		min = 1,
		max = 10,
		step = 0.5,
		onMaxChange,
	} = props;

	useEffect(() => {
		if (onMaxChange) {
			onMaxChange(max);
		}
	}, [max, onMaxChange]);

	const getColor = (rating) => {
		const hue = (rating - min) * (120 / (max - min));
		return `hsl(${hue}, 100%, 50%)`;
	};

	const handleRatingClick = (ratingValue) => {
		if (selectedRating === ratingValue) {
			setSelectedRating(null);
		} else {
			setSelectedRating(ratingValue);
		}
	};

	return (
		<div className="rating-container">
			{label && (
				<div className="field-label-container">
					<div className="field-label">{label}</div>
					{required && <div className="field-required">*</div>}
				</div>
			)}
			<div className="rating-options-container my-1">
				{Array.from(
					{length: (max - min) / step + 1},
					(_, i) => min + i * step,
				).map((ratingValue, index) => {
					return (
						<div
							key={ratingValue}
							className={`rating-box ${selectedRating >= ratingValue ? "selected" : ""} ${setSelectedRating && !disabled ? "clickable" : ""}`}
							style={{
								backgroundColor:
									selectedRating >= ratingValue
										? getColor(ratingValue)
										: COLORS.border,
							}}
							onClick={
								setSelectedRating && !disabled
									? () => handleRatingClick(ratingValue)
									: undefined
							}
						>
							{ratingValue}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default Rating;
